import { Button, makeStyles, tokens } from '@fluentui/react-components';
import {LockClosedFilled, ArrowBounce48Regular} from '@fluentui/react-icons';
import AzureDevOpsIcon from 'src/assets/svg/azure-devops.svg';
import { useAuthorizationStep } from '.';

export function Instructions() {
	const styles = useStyles();
	const { setStep } = useAuthorizationStep();

	return (
		<div className={styles.root}>
			<div className={styles.content}>
				<p>
					{'Appgami Automation watches your Azure DevOps project for changes, like when a work item is created, updated, or moves to a new state. When something matches a rule you\'ve built, it automatically runs the actions you defined: updating fields, adding comments, or sending notifications.'}
				</p>
				<span className={styles.iconContainer}>
					<img src={AzureDevOpsIcon} alt="icon" className={styles.azureDevOpsIcon} />
					<span className={styles.iconsMiddleContainer}>
						<ArrowBounce48Regular className={styles.arrowLeftRegular} />
						<LockClosedFilled className={styles.lockClosedFilled} />
						<ArrowBounce48Regular className={styles.arrowRightRegular} />
					</span>
					<span className={styles.iconsRightContainer}>
						<p className={styles.iconsRightContainerText}>Appgami <br/> Automation</p>
					</span>
				</span>
			</div>
			<div className={styles.bottomRoot}>
				<span className={styles.Bottomline} />
				<div className={styles.BottombuttonArea}>
					<Button
						appearance="primary"
						onClick={() => {
							setStep(2);
						}}
					>
            Next
					</Button>
				</div>
			</div>
		</div>
	);
}

const useStyles = makeStyles({
	root: {
		padding: '24px 0px 24px 0px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
	},
	content: {
		maxWidth: '600px',
		textAlign: 'center',
	},
	azureDevOpsIcon: {
		width: '100px',
		height: '100px',
	},
	arrowLeftRegular: {
		width: '64px',
		height: '64px',
		rotate: '180deg',
		color: tokens.colorNeutralForeground1,
	},
	arrowRightRegular: {
		width: '64px',
		height: '64px',
		color: tokens.colorNeutralForeground1,
	},
	lockClosedFilled: {
		width: '32px',
		height: '32px',
		color: tokens.colorNeutralForeground1,
	},
	iconContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '24px',
		padding: '32px 16px',
	},  
	iconsMiddleContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	iconsRightContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '16px',
	},
	iconsRightContainerText: {
		fontSize: '16px',
		fontWeight: '600',
		color: tokens.colorNeutralForeground1,
	},
	bottomRoot: {
		width: '100%',
		maxWidth: '600px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		gap: '16px',
	},
	Bottomline: {
		display: 'block',
		width: '100%',
		height: '1px',
		backgroundColor: tokens.colorSubtleBackgroundSelected,
	},
	BottombuttonArea: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		gap: '16px',
		width: '100%',
	}
});